<script lang="ts">
    
    import type { State } from "../../Model/State";
    import { uuidGenerator } from "../../Services";

    export let checked: State<boolean>;
    export let label: string;

    const elementId = uuidGenerator.createUuid();

</script>

<div class="form-check">
    <input class="form-check-input" type="checkbox" bind:checked={$checked} id={elementId}>
    <label class="form-check-label" for={elementId}>{label}</label>
</div>
